module.exports = __webpack_public_path__ + "static/media/onlineshopping.d8776f86.svg";